// Currency formatting utilities (multi-currency support)

/**
 * Formate un montant en Dinar Algérien (DA).
 * @deprecated Use formatBrandMoney() from brandCurrency.js — kept for legacy Algeria builds only.
 * @param {number} amount - Le montant à formater
 * @param {boolean} showSymbol - Afficher le symbole DA
 * @returns {string} - Le montant formaté
 */
export const formatDZD = (amount, showSymbol = true) => {
  if (typeof amount !== 'number') {
    amount = parseFloat(amount) || 0;
  }
  
  // Format avec séparateurs de milliers et centimes (pour les gros montants on limite les décimales)
  const formatOptions = amount > 1000000 ? 
    { minimumFractionDigits: 0, maximumFractionDigits: 0 } : 
    { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  
  const formatted = new Intl.NumberFormat('fr-DZ', formatOptions).format(amount);
  
  return showSymbol ? `${formatted} DA` : formatted;
};

/**
 * Convertit EUR vers DA (taux approximatif)
 * @param {number} eurAmount - Montant en EUR
 * @returns {number} - Montant en DA
 */
export const convertEURtoDZD = (eurAmount) => {
  const exchangeRate = 146.5; // Taux approximatif EUR/DA
  return Math.round(eurAmount * exchangeRate);
};

/**
 * Parse recap lines such as `133 280,00 DA` or `-21 280,56 DA` (fr-DZ / Intl output).
 * Strips separators correctly so the comma is not blindly removed (otherwise
 * `133 280,00` becomes `13328000`, breaking montant-en-lettres).
 */
export const parseFrenchDzAmountDisplay = (raw) => {
  if (raw == null || raw === '') return NaN;
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;

  let s = String(raw)
    .trim()
    .replace(/DA/gi, '')
    .replace(/\u202f|\u00a0/g, ' ')
    .trim();

  let sign = 1;
  if (/^-/.test(s)) {
    sign = -1;
    s = s.slice(1).trim();
  }

  const lastComma = s.lastIndexOf(',');
  if (lastComma !== -1) {
    const intPart = s.slice(0, lastComma).replace(/\s+/g, '').replace(/[^\d]/g, '');
    const decPart = s.slice(lastComma + 1).replace(/\s+/g, '').replace(/[^\d]/g, '') || '0';
    const n = parseFloat(`${intPart}.${decPart}`);
    return Number.isFinite(n) ? sign * n : NaN;
  }

  const n = parseFloat(s.replace(/\s+/g, '').replace(/[^\d]/g, ''));
  return Number.isFinite(n) ? sign * n : NaN;
};

/** Bordereau d'envoi : montant « Arrêtée » = Valeur déclarée (DA) uniquement. */
export function resolveShippingSlipDeclaredValueAmount(formData, shippingSlipData) {
  const raw =
    formData?.shipmentDeclaredValue ??
    formData?.declaredValue ??
    shippingSlipData?.declaredValue;
  const n = parseFrenchDzAmountDisplay(raw);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/**
 * Données spécifiques à l'Arabie saoudite
 */
export const saudiData = {
  regions: [
    'الرياض', 'مكة المكرمة', 'المدينة المنورة', 'الدمام', 'الخبر', 'جدة', 'بريدة', 'أبها', 'تبوك', 'حائل',
  ],

  businessTypes: [
    'LLC', 'JSC', 'JSC_CLOSED', 'PARTNERSHIP', 'SOLE_PROP', 'BRANCH', 'PROFESSIONAL',
  ],

  taxTypes: {
    VAT: 15,
    ZAKAT: 2.5,
  },
};

/** @deprecated Use saudiData — kept for backward-compatible imports during migration. */
export const algerianData = saudiData; 
